export default {
  common: {
    casino: "کیسینو",
    more: "مزید",
    searchGames: "گیمز تلاش کریں",
    copied: "کاپی ہو گیا!",
    inputTooLong: "درج کردہ مواد بہت طویل ہے، براہ کرم دوبارہ درج کریں۔",
    inputNameCn: "صرف چینی، انگریزی حروف، اعداد اور انڈر اسکور کی اجازت ہے",
    inputCapital: "صرف بڑے حروف اور انڈر اسکور کی اجازت ہے",
    inputLowercaseUnderscore: "صرف چھوٹے حروف اور انڈر اسکور کی اجازت ہے",
    inputLowercase: "صرف چھوٹے حروف کی اجازت ہے",
    inputNoSpace: "براہ کرم صرف خالی جگہ درج نہ کریں",
    inputValidPhone: "براہ کرم درست فون نمبر درج کریں",
    inputNonNumber: "غیر عددی حروف شامل ہیں",
    inputNonLetter: "غیر حرفی حروف شامل ہیں",
    inputLetterOrNumberOnly: "صرف حروف یا اعداد کی اجازت ہے",
    phoneFormatError: "فون نمبر کا فارمیٹ غلط ہے",
    inputLetterStartNumber: "حرف سے شروع ہونا چاہیے اور اعداد شامل ہو سکتے ہیں",
    inputNoChinese: "چینی حروف کی اجازت نہیں ہے",
    inputChineseOnly: "صرف چینی حروف کی اجازت ہے",
    emailFormatError: "ای میل کا فارمیٹ غلط ہے",
    urlFormatError: "URL کا فارمیٹ غلط ہے",
    jsonFormatError: "JSON کا فارمیٹ غلط ہے",
    networkError: "سرور تک رسائی ناکام رہی، براہ کرم بعد میں دوبارہ کوشش کریں۔",
    siteUnavailable: "یہ سائٹ اس وقت دستیاب نہیں ہے، براہ کرم منتظم سے رابطہ کریں۔",
    tokenExpired: "آپ کا سیشن ختم ہو گیا ہے، براہ کرم دوبارہ سائن ان کریں۔",
    domainNotAuthorized: "ڈومین مجاز نہیں ہے",
    demoEnvOnly: "ڈیمو ماحول، صرف پیش نظارہ کے لیے",
    passwordLength630: "6-30 حروف",
    newPasswordSameAsOld: "نیا پاس ورڈ پرانے پاس ورڈ جیسا نہیں ہو سکتا",
    confirmNewPassword: "براہ کرم اپنے نئے پاس ورڈ کی تصدیق کریں",
    passwordsDoNotMatch: "پاس ورڈ مماثل نہیں ہے",
    withdrawPasswordChanged: "نکالنے کا پاس ورڈ کامیابی سے تبدیل ہو گیا",
    withdrawPasswordSet: "نکالنے کا پاس ورڈ کامیابی سے سیٹ ہو گیا",
    withdrawPasswordSetFailed: "نکالنے کا پاس ورڈ سیٹ کرنے میں ناکامی",
    phoneDigitsOnly: "فون نمبر صرف ہندسوں پر مشتمل ہونا چاہیے",
    phoneTooShort: "فون نمبر بہت مختصر ہے (کم از کم {min} ہندسے)",
    phoneTooLong: "فون نمبر بہت طویل ہے (زیادہ سے زیادہ {max} ہندسے)",
    phoneInvalidPrefix: "فون نمبر کا سابقہ غلط ہے",
    rolloverAll: "تمام اقسام",
    rolloverAllStats: "تمام حالتیں",
    rolloverSuccessful: "کامیاب",
    rolloverFailed: "ناکام",
    rolloverInProgress: "جاری ہے",
    rolloverSuccess: "کامیاب",
    rolloverPending: "زیر التوا",
    rolloverCompleted: "مکمل",
    rolloverCancelled: "منسوخ",
    rolloverExpired: "میعاد ختم",
    walletCash: "نقد",
    walletBonus: "بونس",
    sourceDeposit: "ڈپازٹ",
    sourceCommission: "کمیشن",
    sourceManualAdd: "دستی اضافہ",
    sourceManualSubtract: "دستی کٹوتی",
  },
  redeemCode: {
    enterTip: "انعامات حاصل کرنے کے لیے اپنا ریڈیم کوڈ درج کریں",
    placeholder: "براہ کرم اپنا کوڈ درج کریں",
    redeemBtn: "ریڈیم کریں",
    pleaseEnterCode: "براہ کرم اپنا ریڈیم کوڈ درج کریں",
    redeemSuccess: "ریڈیم کامیاب!",
    redeemFailed: "ریڈیم ناکام، دوبارہ کوشش کریں",
  },
}
